import React, { useState } from "react";
import { Box, Toolbar, AppBar, Typography, Button, IconButton, Menu, MenuItem, ListItemIcon, Divider, Avatar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import NotificationBell from "../components/NotificationBell";
import { clearAuthUser, getAuthUserInitial, getStoredAuthUser } from "../utils/authUser";

export const DRAWER_WIDTH = 240;
export const TOOLBAR_HEIGHT = 72;

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [openMobile, setOpenMobile] = useState(false);
  const [authUser] = useState(() => getStoredAuthUser());

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
const open = Boolean(anchorEl);

const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
  setAnchorEl(event.currentTarget);
};

const handleMenuClose = () => {
  setAnchorEl(null);
};

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    clearAuthUser();
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex" }}>
  
  {/* Sidebar */}
  <NavBar
    openMobile={openMobile}
    onMobileClose={() => setOpenMobile(false)}
  />

  {/* Main */}
  <Box
    component="main"
    sx={{
      flexGrow: 1,
      width: { lg: `calc(100% - ${DRAWER_WIDTH}px)` },
      ml: { lg: `${DRAWER_WIDTH}px` },
    }}
  >
    
    {/* AppBar */}
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { lg: `calc(100% - ${DRAWER_WIDTH}px)` },
        ml: { lg: `${DRAWER_WIDTH}px` },
        bgcolor: "white",
        borderBottom: "1px solid #eee",
      }}
    >
      <Toolbar sx={{ minHeight: TOOLBAR_HEIGHT }}>
        <IconButton
          onClick={() => setOpenMobile(true)}
          sx={{ display: { lg: "none" }, mr: 2 }}
        >
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" sx={{ flexGrow: 1, color: "primary.main" }}>
          Admin Portal
        </Typography>

        <NotificationBell />

        <Box>
  <IconButton onClick={handleMenuOpen}>
    <Avatar sx={{ width: 36, height: 36 }}>
      {getAuthUserInitial(authUser)}
    </Avatar>
  </IconButton>

  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={handleMenuClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <MenuItem disabled>
  <Box>
    {/* <Typography variant="subtitle2">{authUser.name}</Typography> */}
    {authUser.email && (
      <Typography variant="caption">{authUser.email}</Typography>
    )}
  </Box>
</MenuItem>

    <Divider />

    <MenuItem
      onClick={() => {
        handleMenuClose();
        handleLogout();
      }}
    >
      <ListItemIcon>
        <LogoutIcon fontSize="small" />
      </ListItemIcon>
      Logout
    </MenuItem>
  </Menu>
</Box>
      </Toolbar>
    </AppBar>

    {/* Spacer */}
    <Toolbar sx={{ minHeight: TOOLBAR_HEIGHT }} />

    {/* Content */}
    <Box sx={{ p: 3 }}>
      <Outlet />
    </Box>
  </Box>
</Box>
  );
};

export default AdminDashboard;
